import React from 'react'
import { useFence } from '../contexts/FenceContext'
import { TabNavigation } from '.'

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { state, dispatch } = useFence()

  const handleTabChange = (tab: 'konfigurator' | 'wizualizator') => {
    dispatch({ type: 'SET_ACTIVE_TAB', payload: tab })
  }

  return (
    <div className="h-screen bg-gray-200 overflow-hidden flex flex-col touch-manipulation">
      <TabNavigation 
        activeTab={state.activeTab} 
        onTabChange={handleTabChange} 
      />
      <div className="flex-1 overflow-hidden relative">
        {children}
      </div>
    </div>
  )
}

export default Layout
